import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9g6pdps5f: FaireProductEntity = {
  token: "p_j9g6pdps5f",
  type: "product",
  name: "Evil Eye Suncatcher – Gemstone Hanging Wall & Window Décor",
  brandToken: "b_9aggj4kudk",
  brandName: "Earth's Gems BTQ",
  imageUrl:
    "https://cdn.faire.com/fastly/8c5bcfa8d164213a667fc1ce460091b945c5d5242062d61468ba4ca159ec656c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/73dca4a3908da9c9400dcd52535df4160e918e06b911ccdd90734cb6b42d1c82.jpeg",
    "https://cdn.faire.com/fastly/c5876b392ca02d3022f3dffd5a19bd2b34e71aa75553fb6b392bdd76f78213a6.jpeg",
    "https://cdn.faire.com/fastly/b232be28472a1434fa901f6bade460c374c7b0a4ff50b85cfb0601d53f9490e0.jpeg",
  ],
  priceDollars: 14,
  description:
    "✨ Bring balance, beauty, and calming energy into your home with our Oval Crystal Zen Garden Night Lamp. Handcrafted with genuine crystals arranged inside a glowing oval frame, this lamp transforms any space into a sanctuary of peace.\n\n🌙 Why You’ll Love It:\n\n * \nAuthentic Crystals: Each lamp is filled with natural gemstones such as clear quartz, amethyst, aventurine, and more — chosen for their unique energy and beauty.\n\n * \nSoothing LED Glow: The warm light creates a tranquil atmosphere, perfect for meditation, relaxation, or bedtime rituals.\n\n * \nMindful Design: The oval frame and crystal garden aesthetic bring grounding harmony to your home décor.\n\n * \nVersatile Use: Ideal for bedrooms, living rooms, meditation spaces, or as a thoughtful gift.\n\n✨ Details:\n\n * \nOval-shaped LED lamp with embedded crystals & greenery accents\n\n * \nHeight: approx. 8–10 in. (varies slightly due to handcrafted nature)\n\n * \nPower: USB connection (with on/off switch)\n\n * \nEnergy-efficient warm LED lighting\n\n * \nCrystals may include: Clear Quartz, Amethyst, Aventurine, Citrine, Obsidian, and others\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:08.903Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
